import React, { useEffect, useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { apiUrl } from '../apiBase';

const SuperadminGuard = ({ children }) => {
  const location = useLocation();
  const [status, setStatus] = useState('checking'); // checking | allowed | login | unauthorized

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const res = await fetch(apiUrl('/superadmin/me'), { credentials: 'include' });
        if (!cancelled) {
          if (res.ok) setStatus('allowed');
          else if (res.status === 401) setStatus('login');
          else setStatus('unauthorized');
        }
      } catch (e) {
        if (!cancelled) setStatus('login');
      }
    })();
    return () => { cancelled = true; };
  }, []);

  if (status === 'checking') return null;
  if (status === 'unauthorized') return <Navigate to={{ pathname: '/admin/unauthorized' }} replace state={{ from: location }} />;
  return children;
};

export default SuperadminGuard;
